<template>
    <div class="h100">
        <div class="h100 flex-column scroll">
            <div class="flex w100 bg-white pt15 pl15 pr15">
                <div>
                    <span class="">律师函详情</span>
                </div>
                <div class="flex-width"></div>
                <!-- <div @click="edit" v-if="form.data.status == 3||form.data.status == 2" style="background-color: #eb6d69; height: 25px; line-height: 25px; color: white;" class="fs12 pl12 pr12 cursor-pointer">编辑</div>
                <div @click="del" v-if="form.data.status == 3" style="background-color: #eb6d69; height: 25px; line-height: 25px; color: white;" class="fs12 pl12 pr12 cursor-pointer ml3">删除</div> -->
                
                <!-- <div class="flex-width"></div> -->
            </div>
            <div class="flex items-center bg-white pl15 pr15 pb15">
                <div class="flex-width flex items-center mt10">
                    <div class="fs12 flex-width">
                        <div class="a70">项目名称</div>
                        <div class="fs12 one-line">{{form.project_name}}</div>
                    </div>
                    <div class="fs12 flex-width ml10">
                        <div class="a70">申请日期</div>
                        <div v-if="form.create_time != null" class="fs12">{{form.create_time}}</div>
                        <div v-else>--</div>
                    </div>
                    <div class="fs12 flex-width ml10"></div>
                </div>
            </div>
            <div class="mt15 bg-white pd15">
                <div class="">
                    <div class="">
                        <div>
                            <div class="fs14 bold">
                                详细信息
                            </div>
                            <div class="mt20">
                                <div class="flex">
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">项目</div>
                                            <div style="">{{form.project_name}}</div>
                                        </div>
                                    </div>
                                    <div class="flex-width"></div>
                                </div>

                                <div class="flex mt15">
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                发函时间
                                            </div>
                                            <div style="">{{ (form.release_time)?form.release_time:"--" }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                收件日期
                                            </div>
                                            <div style="">{{ (form.receive_time)?form.receive_time:"--" }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex mt15">
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                我方单位
                                            </div>
                                            <div style="">{{ (form.company_entity)?form.company_entity:"--" }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                核对金额
                                            </div>
                                            <div style="">{{ (form.check_amount)?form.check_amount:"--" }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex mt15">
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                发函单位
                                            </div>
                                            <div style="">{{ (form.release_entity)?form.release_entity:"--" }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                单位属性
                                            </div>
                                            <div style="">{{ (form.entity_prop)?form.entity_prop:"--" }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex mt15">
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                委托律所
                                            </div>
                                            <div style="">{{ (form.law_firm_name)?form.law_firm_name:"--" }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                发函诉求
                                            </div>
                                            <div style="">{{ (form.appeal)?form.appeal:"--" }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex mt15">
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                联系人
                                            </div>
                                            <div style="">{{ (form.contact_person)?form.contact_person:"--" }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">
                                                联系电话
                                            </div>
                                            <div style="">{{ (form.contact_person_phone)?form.contact_person_phone:"--" }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex mt15">
                                    <div class="flex-width">
                                        <div class="flex items-center">
                                            <div style="width: 100px;">备注</div>
                                            <div style="">{{ (form.remark)?form.remark:"--" }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-width">
                                        <div class="flex">
                                            <div style="width: 100px;">上传材料</div>
                                            <div class="fs13 pr20">
                                                <div v-for="(src, i) in form.attachmentData" :key="i">
                                                    <div class="flex items-center">
                                                        <a class="one-line" @click="preview(src)" style="text-decoration:none;">
                                                            <span>{{src.name}}</span>
                                                        </a>
                                                        <a-icon class="ml10" type="vertical-align-bottom" @click="downLoadPdf(src)"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt15 bg-white pd15">
                <div class="flex" style="justify-content: space-between;">
                    <div class="flex-1">
                        <div>系统信息</div>
                        <a-row :gutter="16" class="fs16 mt20">
                            <a-col :span="8">
                                <div class="fs13" style="color:grey;font-weight: bolder;">创建人</div>
                                <div class="fs14">{{((form.create_person != "")&&(form.create_person != null))?form.create_person:"--"}}</div>
                            </a-col>
                            <a-col :span="8">
                                <div class="fs13" style="color:grey;font-weight: bolder;">创建时间</div>
                                <div class="fs14">{{((form.create_time != "")&&(form.create_time != null))?form.create_time.replace("T", " "):"--"}}</div>
                            </a-col>
                            <a-col :span="8">
                                <div class="fs13" style="color:grey;font-weight: bolder;">修改时间</div>
                                <div class="fs14">{{((form.modify_time != "")&&(form.modify_time != null))?form.modify_time.replace("T", " "):"--"}}</div>
                            </a-col>
                        </a-row>
                    </div>
                </div>
            </div>
        </div>
        <a-modal title="预览" v-model="image_visible" @ok="downImg(preview_url)" okText="下载到本地" cancelText="返回" @cancel="image_visible = false">
            <div class="w100 h100">
                <img :src="preview_url" alt="" width="100%" height="100%" style="object-fit: contain;" :data-original="preview_url">
            </div>
        </a-modal>
        <a-modal
            :title="previewDoc.title"
            :visible="docVisible"
            width="100%"
            centered
            @cancel="docVisible=false"
            :footer="null"
            >
            <div v-if="previewDoc.isPdf">
                <pdf :src="previewDoc.url" v-for="item in numPages"
                    :key="item"
                    :page="item"
                ></pdf>
            </div>
            <div v-else>
                <VueDocPreview :value="previewDoc.url" :type="previewDoc.docType" />
            </div>
        </a-modal>
    </div>
</template>

<script>
	export default ({
        props:{
            form:{
                type: Object,
            }
        },
		components: {
            
		},
		data() {
			return {
                image_visible:false,
                docVisible:false,
                preview_url:"",
                previewDoc: {
                    title: "",
                    isPdf: false
                },
			}
		},
		created(){
            
		},
		methods:{
            preview(item){
                this.previewDoc.title = item.name;
                this.previewDoc.url = item.url;
                this.preview_url = item.url;
                let suffix = this.previewDoc.title.substring(this.previewDoc.title.lastIndexOf(".") + 1)
                if(suffix == "jpg" || suffix == "png"){
                    this.image_visible = true
                }else if(suffix == "rar" || suffix == "zip"){
                    this.$message.error("该文件为压缩包文件，不支持预览，请下载后解压查看")
                }else{
                    if (suffix == "pdf") {
                        const link = document.createElement('a');
                        link.href = item.url;
                        link.download = item.name; // 设置下载的文件名，根据实际需要修改
                        link.target = '_blank'; // 在新窗口打开下载链接
                        link.click(); // 模拟点击触发下载
                    }else if(suffix == "docx" || suffix == "xlsx" || suffix == "pptx"){
                        this.previewDoc.url = "https://api.hidocs.cn/api?furl=" + this.previewDoc.url;
                        window.open(this.previewDoc.url)
                    }else{
                        this.previewDoc.url = "http://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(this.previewDoc.url);
                        window.open(this.previewDoc.url)
                        this.previewDoc.isPdf = false;
                        this.previewDoc.docType = "office";
                        // window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(item.url));

                        // this.docVisible = true;
                    }
                }
            },
            downImg(item){
                // const link = document.createElement('a');
                // link.href = item;
                // link.download = 'image.jpg'; // 设置下载的文件名，根据实际需要修改
                // link.target = '_blank'; // 在新窗口打开下载链接
                // link.click(); // 模拟点击触发下载
                this.getBlob(this.previewDoc.url, (blob) => {
                    this.saveAs(blob, this.previewDoc.title)
                })
            },
            // downLoadPdf(src){
            //     const link = document.createElement('a');
            //     link.href = src.url;
            //     link.setAttribute('target', '_blank');
            //     link.setAttribute('rel', 'noopener noreferrer');
            //     document.body.appendChild(link);
            //     link.click();
            //     document.body.removeChild(link);
            // },
            downLoadPdf(src){
                this.getBlob(src.url, (blob) => {
                    this.saveAs(blob, src.name)
                })
            },
            getBlob(url, cb) {
                var xhr = new XMLHttpRequest()
                xhr.open('GET', url, true)
                xhr.responseType = 'blob'
                xhr.onload = function() {
                    if (xhr.status === 200) {
                    cb(xhr.response)
                    }
                }
                xhr.send()
            },
            saveAs(blob, filename) {
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename)
                }
                else {
                    var link = document.createElement('a')
                    var body = document.querySelector('body')

                    link.href = window.URL.createObjectURL(blob)
                    link.download = filename

                    link.style.display = 'none'
                    body.appendChild(link)

                    link.click()
                    body.removeChild(link)
                    window.URL.revokeObjectURL(link.href)
                }
            },
		}
	})

</script>

<style lang="scss" scoped>

</style>